export const handlePdf = ({ file, id, name }: { file: string; id: string; name: string }) => {
  const byteCharacters = atob(file);
  const byteNumbers = Array.from({ length: byteCharacters.length }, (_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  const blobFile = new Blob([byteArray], { type: 'application/pdf' });

  const url = window.URL.createObjectURL(blobFile);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${name}-${id}.pdf`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  window.URL.revokeObjectURL(url);
};
